import { render, staticRenderFns } from "./CustomError.vue?vue&type=template&id=a5a30e0e"
import script from "./CustomError.vue?vue&type=script&lang=js"
export * from "./CustomError.vue?vue&type=script&lang=js"
import style0 from "./CustomError.vue?vue&type=style&index=0&id=a5a30e0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports